module.exports = __webpack_public_path__ + "static/capcalera-llibre-es-42a6c3c2d2e34955640307725f3d3701.jpg";